import { FC } from 'react'

interface ISpinnerProps {
	className?: string
}

const Spinner: FC<ISpinnerProps> = ({ className }) => {
	return (
		<div
			className={`fixed z-10 top-1/2 left-1/2 w-20 h-20 rounded-full border-[5px] 
                 border-transparent border-t-gray-500 border-l-gray-500 animate-spin-center ${className}`}
		/>
	)
}

export default Spinner
